import { Component, Element, h, Host, Listen, Prop, State } from '@stencil/core';

@Component({
  tag: 'pn-breakpoints',
  styleUrl: 'pn-breakpoints.scss',
})
export class PnBreakpoints {
  @Element() hostElement: HTMLElement;
  @State() currentWidth: number = window.innerWidth;
  @Prop() breakPointClass: string = 'dotcom';

  @Listen('resize', { target: 'window' })
  handleViewportSizeChange(event: any) {
    this.currentWidth = event.target.innerWidth;
  }

  createBreakpointClass() {
    return `breakpoints--${this.breakPointClass}`;
  }

  render() {
    return (
      <Host>
        <div class={`breakpoints ${this.createBreakpointClass()} `}>
          {`${this.currentWidth} px`}
          {' min-width: '}
          <span class="reference">{' px'}</span>
        </div>
      </Host>
    );
  }
}
